export default {
  aboutKs: {
    kcl: 'https://www.kcl.re.kr/site/homepage/menu/viewMenu.do?menuid=001013001001001',
    ktc: 'http://www.ktc.re.kr/web_united/task/task.asp?pagen=1704',
    ktr: 'http://ktr.or.kr/certification/ks/contentsid/447/index.do',
    kilt: 'http://www.kilt.re.kr/html/dh/certi0101',
    fiti: 'https://www.fiti.re.kr/?sub_num=729',
  },
  address: {
    kcl: '(06711) 서울특별시 서초구 남부순환로 319길 7(서초동)',
    ktc: '(15809) 경기도 군포시 흥안대로27번길 22',
    ktr: '(13810) 경기도 과천시 교육원로98(중앙동)',
    kilt: '(14523) 경기도 부천시 원미구 도약로 261, 대우 테크노파크 A동 403호',
    fiti: '(07791) 서울특별시 강서구 마곡중앙8로3길 79(마곡동)',
  },
  labAddress: {
    kcl: '서울특별시 서초구 남부순환로 319길 7',
    ktc: '경기도 군포시 흥안대로 27번길 22',
    ktr: '경기도 과천시 교육원로 98(중앙동)',
    kilt: '경기도 부천시 도약로 261 A-403',
    fiti: '서울특별시 강서구 마곡중앙8로3길 79(마곡동)',
  },
  labTelephone: {
    kcl: '',
    ktc: '',
    ktr: '',
    kilt: '',
    fiti: '',
  },
  ceoName: {
    kcl: '조영태',
    ktc: '안성일',
    ktr: '권오정',
    kilt: '조현훈',
    fiti: '김화영',
  },
  name: {
    kcl: '한국건설생활환경시험연구원',
    ktc: '한국기계전기전자시험연구원',
    ktr: '한국화학융합시험연구원',
    kilt: '키엘연구원',
    fiti: 'FITI시험연구원',
  },
  companyNo: {
    kcl: '',
    ktc: '대표전화 031-470-1687, 1649',
    ktr: '107-82-14534',
    kilt: 'TEL : 032-670-3862, 3817',
    fiti: '204-82-00670',
  },
  bankAccount: {
    kcl: '계좌번호: 기업은행 327-052216-04-669 한국건설생활환경시험연구원',
    ktc: '계좌번호: 국민은행 214901-04-280718 한국기계전기전자시험연구원',
    ktr: '<a href="http://www.ktr.or.kr/customer-service/online-deposit/contentsid/366/index.do" target="_blank">입금안내</a>',
    kilt: '계좌번호: 우리은행 298-127979-13-102 키엘연구원',
    fiti: '계좌번호: 국민은행  033-01-0061-589 에프아이티아이 시험연구원',
  },
  msgBankAccount: {
    kcl: '기업은행 327-052216-04-669 한국건설생활환경시험연구원',
    ktc: '국민은행 214901-04-280718 한국기계전기전자시험연구원',
    ktr: '',
    kilt: '우리은행 298-127979-13-102 키엘연구원',
    fiti: '국민은행  033-01-0061-589 에프아이티아이 시험연구원',
  },
  msgFooter: {
    kcl: `\n\n**본 문자는 발신전용으로 회신되지 않습니다.
문의
02-3415-8818(3년정기,접수상담,민원)
02-3415-8812(1년주기)
02-6951-8634(인증서,사후관리)
02-3415-8837(수납,배정)
02-3415-8763(품질관리자 변경, 인증위원회 운영)`,
    ktc: '\n\n본 문자는 발신전용으로 회신되지 않습니다.\n담당자 연락처 031-470-1694 (김미나 주임)',
    ktr: '\n\n본 문자는 발신전용으로 회신되지 않습니다.\n문의 02-2164-1444, 1434',
    kilt: '\n\n본 문자는 발신전용으로 회신되지 않습니다.\n문의 032-670-3862, 3817',
    fiti: '\n\n본 문자는 발신전용으로 회신되지 않습니다.\n대표 02-3299-8000',
  },
  reissueReturn: {
    kcl: '\n원본인증서는 아래의 주소로 발송부탁드립니다. 원본 인증서가 회수되어야 인증서 원본 보내드립니다. \n\n' +
      '보내실 주소:  06711 서울특별시 서초구 남부순환로 319길 7 인증본부 KS품질인증팀 이수정 책임 연구원',
    ktc: '',
    ktr: '',
    kilt: '',
    fiti: '',
  },
  privatePolicy: {
    kcl: 'https://kcl.re.kr/site/homepage/menu/viewMenu.do?menuid=008004001',
    ktc: 'http://www.ktc.re.kr/web_united/etc/privacy_7.asp?pagen=1851',
    ktr: 'http://ktr.or.kr/utility/policy/index.do',
    kilt: 'http://www.kcl.re.kr/site/homepage/menu/viewMenu?menuid=004006001',
    fiti: 'https://www.fiti.re.kr/?sub_num=366',
  },
  contacts: {
    kcl: [{
      type: '접수상담(신규,정기,기관변경),시판품', name: '안종하', grade: '수석', tel: '02-3415-8818', email: 'ks@kcl.re.kr',
    }, {
      type: '심사일정,심사원배정,수납', name: '변선희', grade: '책임', tel: '02-3415-8837', email: 'ks@kcl.re.kr',
    }, {
      type: '인증위원회 인증심의,심사기준', name: '박찬', grade: '책임', tel: '02-3415-8763', email: 'ks@kcl.re.kr',
    }, {
      type: '1년주기,인증서,사후관리(자재변경,생산중단등)', name: ' 조혜정', grade: '책임', tel: '02-3415-8884', email: 'ks@kcl.re.kr',
    }],
    ktc: [{
      type: '', name: '지승렬', grade: '책임', tel: '031-470-1687', email: 'bosco@ktc.re.kr',
    }, {
      type: '', name: '정용진', grade: '수석', tel: '031-470-1694', email: 'yjjeong@ktc.re.kr',
    }],
    ktr: [{
      type: '인증운영실 업무총괄', name: '한춘근', grade: '실장', tel: '02-2164-1401', email: 'han1021@ktr.or.kr',
    }, {
      type: 'KS인증기관 운영', name: '이상호', grade: '수석연구원', tel: '02-2164-1404', email: 'ssarori@ktr.or.kr',
    }, {
      type: 'KS인증기관 운영', name: '양승복', grade: '책임연구원', tel: '02-2164-1406', email: 'mpv1210@ktr.or.kr',
    }, {
      type: 'KS인증기관 운영', name: '박현정', grade: '책임연구원', tel: '02-2164-1405', email: 'phj@ktr.or.kr',
    }, {
      type: 'KS인증기관 운영', name: '전현숙', grade: '책임연구원', tel: '02-2164-1407', email: 'sook@ktr.or.kr',
    }],
    kilt: [{
      type: 'KS인증총괄', name: '고정배', grade: '선임', tel: '032-670-3862', email: 'kjb@kilt.re.kr',
    }, {
      type: 'KS인증실무', name: '김도형', grade: '선임', tel: '032-670-3817', email: 'dohyeong@kilt.re.kr',
    }, {
      type: 'KS인증실무', name: '김다혜', grade: '연구원', tel: '032-670-3864', email: 'bong23@kilt.re.kr',
    }],
    fiti: [{
      type: '', name: '장철민', grade: '책임', tel: '02-3299-8051', email: 'cmjang@fiti.re.kr',
    }, {
      type: '', name: '남궁준', grade: '주임', tel: '02-3299-8224', email: 'june.nk@fiti.re.kr',
    }],
    // {
    //   type: '', name: '안광호', grade: '팀장', tel: '010-9969-3905', email: 'justin.an@fiti.re.kr',
    // },
  },
  links: {
    kcl: {
      prepareGuide: 'https://www.kcl.re.kr/site/homepage/menu/viewMenu.do?menuid=001013001001006',
      procedureGuide: 'https://www.kcl.re.kr/site/homepage/menu/viewMenu.do?menuid=001013001001001',
      criteriaGuide: 'http://standard.go.kr/KSCI/portalindex.do',
      feeGuide: 'https://www.kcl.re.kr/site/homepage/menu/viewMenu.do?menuid=001013001001006',
      csGuide: '/kcl/complaint/step',
      manualDownload: '/api/download/document/KS인증_메뉴얼(KCL).pdf',
      ceoAgreementDocument: '/api/download/kcl/대표자동의서.hwp',
      materialDocument: '/api/download/kcl/주요자재목록.hwp',
      testEquipDocument: '/api/download/kcl/시험(검사)설비보유현황.hwp',
      produceEquipDocument: '/api/download/kcl/제조(가공)설비보유현황.hwp',
      wayToUs: 'https://kcl.re.kr/site/homepage/menu/viewMenu.do?menuid=001017009',
      qualityLicenseDocument: '/api/download/document/품질관리담당자 자격관리 신고서.hwp',
    },
    ktr: {
      prepareGuide: 'http://ktr.or.kr/certification/ks/contentsid/447/index.do',
      procedureGuide: 'http://ktr.or.kr/certification/ks/contentsid/447/index.do',
      criteriaGuide: 'http://standard.go.kr/KSCI/portalindex.do',
      feeGuide: '/ktr/new/guide#fee',
      csGuide: '/ktr/complaint/step',
      manualDownload: '/api/download/document/KS인증_메뉴얼(KTR).pdf',
      ceoAgreementDocument: '/api/download/ktr/QP양식10-01 구비서류 샘플1_공평성 요구사항 체크리스트 (기업용).hwp',
      materialDocument: '/api/download/ktr/주요자재목록.hwp',
      testEquipDocument: '/api/download/ktr/QP양식10-01 구비서류 샘플5_시험(검사) 설비보유 목록.hwp',
      produceEquipDocument: '/api/download/ktr/QP양식10-01 구비서류 샘플3_제조설비 목록.hwp',
      changeDocument: '/api/download/ktr/QP양식10-03_인증기관변경신청서.hwp',
      wayToUs: 'http://www.ktr.or.kr/introduce/location/contentsid/507/index.do',
      qualityLicenseDocument: '/api/download/document/품질관리담당자 자격관리 신고서.hwp',
    },
    ktc: {
      prepareGuide: 'http://www.ktc.re.kr/web_united/task/task.asp?pagen=1705',
      procedureGuide: 'http://www.ktc.re.kr/web_united/task/task.asp?pagen=1705',
      criteriaGuide: 'http://standard.go.kr/KSCI/portalindex.do',
      feeGuide: 'http://www.ktc.re.kr/web_united/task/task.asp?pagen=1705',
      csGuide: 'http://www.ktc.re.kr/web_united/task/task.asp?pagen=1709',
      manualDownload: '/api/download/document/KS인증_메뉴얼(KTC).pdf',
      ceoAgreementDocument: '/api/download/ktc/개인정보수집이용및제3자제공동의서.hwp',
      materialDocument: '/api/download/ktc/(양식)_주요자재_관리목록.hwp',
      testEquipDocument: '/api/download/ktc/(양식)_시험(검사)_설비_보유현황.hwp',
      produceEquipDocument: '/api/download/ktc/(양식)_제조(가공)_설비_보유현황.hwp',
      wayToUs: 'http://www.ktc.re.kr/web_united/introduce/introduce.asp?pagen=1779',
      qualityLicenseDocument: '/api/download/ktc/(양식)_품질관리담당자 자격관리 신고서.hwp',
    },
    kilt: {
      prepareGuide: 'http://www.kilt.re.kr/html/dh/certi0102',
      procedureGuide: 'http://www.kilt.re.kr/html/dh/certi0102',
      criteriaGuide: 'http://standard.go.kr/KSCI/portalindex.do',
      feeGuide: 'http://www.kilt.re.kr/html/dh/certi0102',
      csGuide: '/kilt/complaint/step',
      manualDownload: '/api/download/document/KS인증_메뉴얼(KILT).pdf',
      ceoAgreementDocument: '',
      materialDocument: '/api/download/kilt/자재관리목록(예시).hwp',
      testEquipDocument: '/api/download/kilt/검사설비보유현황(예시).hwp',
      produceEquipDocument: '/api/download/kilt/제조설비보유현황(예시).hwp',
      wayToUs: 'https://kilt.re.kr/html/dh/intro06',
      qualityLicenseDocument: '/api/download/document/품질관리담당자 자격관리 신고서.hwp',
    },
    fiti: {
      prepareGuide: 'https://www.fiti.re.kr/?sub_num=729',
      procedureGuide: 'https://www.fiti.re.kr/?sub_num=729',
      criteriaGuide: 'https://standard.go.kr/',
      feeGuide: 'https://www.fiti.re.kr/?sub_num=729',
      csGuide: '/fiti/complaint/step',
      manualDownload: '/api/download/document/KS인증_메뉴얼(KILT).pdf',
      ceoAgreementDocument: '/api/download/fiti/41. FITI-KS(P)-양식-08-03 Rev No.00_대표자동의서.hwp',
      materialDocument: '/api/download/fiti/46. FITI-KS(P)-양식-08-08 Rev No.01_자재관리목록.hwp',
      testEquipDocument: '/api/download/fiti/44. FITI-KS(P)-양식-08-06 Rev No.00_시험(검사)설비보유현황.hwp',
      produceEquipDocument: '/api/download/fiti/45. FITI-KS(P)-양식-08-07 Rev No.00_제조(가공)설비보유현황.hwp',
      wayToUs: 'https://www.fiti.re.kr/?sub_num=363',
      qualityLicenseDocument: '/api/download/document/품질관리담당자 자격관리 신고서.hwp',
    },
  },
  dummy: {
    kcl: '',
    ktc: '',
    ktr: '',
    kilt: '',
    fiti: '',
  },
};



// WEBPACK FOOTER //
// ./src/data/authorityData.js